var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { EntrySearchIcon } from '@move-ui/icons-asset-catalog';
import { TextInput } from '../TextInput/TextInput';
import styles from './Search.module.css';
export const Search = forwardRef((_a, ref) => {
    var { value, setValue, onChange, onClear } = _a, rest = __rest(_a, ["value", "setValue", "onChange", "onClear"]);
    return (React.createElement("div", { className: styles.search, ref: ref },
        React.createElement(TextInput, Object.assign({ role: "search", iconLeft: React.createElement(EntrySearchIcon, null) }, rest, { value: value, onChange: ({ target }) => {
                setValue(target.value);
                onChange === null || onChange === void 0 ? void 0 : onChange(target.value);
            }, onClear: (currentValue) => {
                setValue('');
                onClear === null || onClear === void 0 ? void 0 : onClear(currentValue);
            } }))));
});
//# sourceMappingURL=Search.js.map